module.exports = __webpack_public_path__ + "img/airasia.dd391d5e.svg";